import React from 'react'
import {IoCalculator} from 'react-icons/io5'

export default function CalculateBtn({onClick, validInput}) {
  return (
    // Always clickable, even when the form is incomplete — onClick decides
    // whether that means "calculate" or "tell the user what's missing"
    // (see IOLExchangeCalculator.js's attemptCalculate). A native
    // `disabled` button would swallow the click entirely.
    <button type="button" id='iolx-calculateBtn'
    className={(validInput)? 'iolx-calculateBtn-enabled styledBox title2'
                           : 'iolx-calculateBtn-disabled styledBox'}
    onClick={onClick}>
        <IoCalculator className='iolx-calculator-icon'/>
        <span className='iolx-calculate-label'>Calculate exchange</span>
    </button>
  )
}
